import React from 'react';

import classNames from 'classnames';

import styles from './Switch.module.scss';

export interface SwitchProps {
    customClass?: {
        Wrapper?: string;
        Input?: string;
    };
    isActive?: boolean;
    onClick?: () => void;
}

const Switch = ({ isActive = false, customClass, onClick }: SwitchProps) => {
    return (
        <div
            onClick={onClick}
            className={classNames(
                { [styles.Active]: isActive },
                styles.Switch,
                customClass?.Wrapper
            )}
        >
            <input
                type="checkbox"
                className={customClass?.Input}
                checked={isActive}
                onChange={() => {}}
            />
        </div>
    );
};

export default Switch;
